export default __webpack_public_path__ + "static/media/laptop.e155ff77.png";